(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/util.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/util.js');
"use strict";


const showNotAvailableDialog = (type, cb) => {
  svs.ticket_gifts.logger.info("Unavailable ticket dialog shown for ticketType: ".concat(type));
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    icon: 'help-2',
    type: svs.components.dialog.type.DEFAULT,
    title: 'Denna lott är inte längre tillgänglig online',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Däremot kan du hämta ut lotter till samma värde hos ditt närmaste ombud.'
    }],
    actions: [{
      title: 'Hämta i butik',
      callback: () => {
        cb();
        svs.components.dialog.api.close();
      }
    }]
  }));
};
const hideNotAvailableDialog = () => svs.components.dialog.api.close();
const setTabIndexOnButton = (button, remove) => {
  if (button) {
    button.tabIndex = remove ? -1 : 0;
  }
};
const onBreakPointChange = () => {
  if (svs.core.detect.breakpoint.greaterThan('md')) {
    showTopHeader();
  } else {
    hideTopHeader();
  }
};
const hideTopHeader = () => {
  const reactContainer = document.querySelector('.js-react-container');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const container = document.querySelector('.js-game-launcher-wrapper');
  const heightDiff = topContent.clientHeight;
  gsap.to(topContent, 1, {
    y: -heightDiff
  });
  gsap.to(aoBrand, 1, {
    y: -heightDiff
  });
  gsap.to(container, 1, {
    y: '-22px',
    marginBottom: '-22px'
  });
  gsap.to(navHamburgerButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, true);
    }
  });
  gsap.to(profileIconButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, true);
    }
  });
  fixedTopContent.style.height = null;
  const newFixedHeight = fixedTopContent.clientHeight - heightDiff;
  reactContainer.style.minHeight = "calc(100vh - ".concat(newFixedHeight, "px)");
  fixedTopContent.style.height = "".concat(newFixedHeight, "px");
};
const showTopHeader = function () {
  let gameFinished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const reactContainer = document.querySelector('.js-react-container');
  const aoBrand = document.querySelector('.corporate-info-ao-brand');
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const container = document.querySelector('.js-game-launcher-wrapper');
  const fixedTopContent = document.querySelector('.js-fixed-top-content');
  gsap.to(topContent, 1, {
    y: 0
  });
  gsap.to(aoBrand, 1, {
    y: 0
  });
  gsap.to(container, 1, {
    y: 0,
    marginBottom: 0
  });
  gsap.to(navHamburgerButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, false);
    }
  });
  gsap.to(profileIconButton, {
    duration: 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, false);
    }
  });
  fixedTopContent.style.height = null;
  if (gameFinished) {
    reactContainer.style.minHeight = "calc(100vh - ".concat(fixedTopContent.clientHeight, "px)");
  }
};
const hideFooter = () => {
  document.querySelector('.page-footer').classList.add('hide-page-footer');
};
const hideHeaders = () => {
  onBreakPointChange();
  svs.core.detect.breakpoint.on('change', onBreakPointChange);
};
const scrollTopContent = () => {
  window.scrollTo({
    top: 1,
    behavior: 'smooth'
  });
};
const redirectToTicketSelector = url => {
  window.location.href = url;
};
setGlobal('svs.ticket_gifts.redeem.components.util', {
  showNotAvailableDialog,
  hideNotAvailableDialog,
  showTopHeader,
  hideHeaders,
  hideTopHeader,
  hideFooter,
  scrollTopContent,
  redirectToTicketSelector
});

 })(window);